import m from "../../geodata/es2015/swedenLow";
window.am4geodata_swedenLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/swedenLow.js
// module id = null
// module chunks = 